import annoucement from './announcement'

export default [annoucement()]



// WEBPACK FOOTER //
// ./src/plugins/built-in.js